/**
 * API client for stress check data retrieval
 */
/**
 * Fetches stress check data from the API
 *
 * @returns {Promise<IStressCheckData[]>} Array of stress check data (currently returns only the latest one)
 */
export async function fetchStressData() {
    try {
        const limit = 1; // Fetch only the latest stress level
        const response = await fetch(`/deepai/api/stress_check/get?limit=${limit}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Ensure we always return an array, even for a single item
        if (Array.isArray(data)) {
            return data;
        }
        else if (data && typeof data === 'object') {
            return [data];
        }
        return [];
    }
    catch (error) {
        console.error('Failed to fetch stress data:', error);
        throw error;
    }
}
/**
 * Parses stress detail JSON string to object
 *
 * @param {string | null} detailString - JSON string from API
 * @returns {IStressDetail | null} Parsed detail object
 */
export function parseStressDetail(detailString) {
    if (!detailString) {
        return null;
    }
    // If detail is already an object, return it
    if (typeof detailString === 'object') {
        return detailString;
    }
    try {
        return JSON.parse(detailString);
    }
    catch (error) {
        console.error('Failed to parse stress detail:', error);
        return null;
    }
}
/**
 * Maps stress level to icon category
 *
 * @param {number} level - Stress level (1-10)
 * @returns {string} Icon category (low, medium, high, veryHigh)
 */
export function mapStressLevelToCategory(level) {
    if (level == 1)
        return 'low';
    if (level == 2)
        return 'medium';
    if (level == 3)
        return 'high';
    if (level == 4)
        return 'veryHigh';
    return 'unknown';
}
